// Predefined categories for tasks.
// Used for populating Select dropdowns. Keep in sync with server if modified manually.

export const TASK_CATEGORIES = [
  { id: 'dev', name: 'Development' },
  { id: 'design', name: 'Design' },
  { id: 'qa', name: 'Quality Assurance' },
  { id: 'devops', name: 'DevOps' },
  { id: 'content', name: 'Content & Copy' },
  { id: 'marketing', name: 'Marketing' },
  { id: 'hr', name: 'Human Resources' },
  { id: 'research', name: 'Research' },
  { id: 'management', name: 'Management' },
  { id: 'other', name: 'Other' },
];
